import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SUPPORT } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { ANDROID_KEYSTORE_GENERATOR_FAQS } from '../../constants';

@Component({
  selector: 'app-android-keystore-generator-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './android-keystore-generator-faq-section.component.html',
  styleUrl: './android-keystore-generator-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AndroidKeystoreGeneratorFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly items = ANDROID_KEYSTORE_GENERATOR_FAQS;
}
